import styles from "./Assignments.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import { FaInstagram } from "react-icons/fa";
import IconAndName from "../../components/IconAndName/IconAndName";
import { RiFileTextLine } from "react-icons/ri";
import CopyRight from "../../components/CopyRight/CopyRight";
import { MdOutlineTextSnippet } from "react-icons/md";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import AssessmentReportsCard from "../../components/AssessmentReportsCard/AssessmentReportsCard";
import DataFilter from "../../components/DataFilter/DataFilter";

const data = [
  {
    _id: "1",
    name: "John Jacob",
    math: 7,
    science: 9,
    social: 5,
    english: 6,
  },
  {
    _id: "2",
    name: "Alice Mathews",
    math: 3,
    science: 4,
    social: 8,
    english: 10,
  },
  {
    _id: "3",
    name: "Raj Verma",
    math: 6,
    science: 5,
    social: 7,
    english: 2,
  },
];
  

function Assignments() {
  const [selectedDate, setSelectedDate] = useState("");
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const [filters, setFilters] = useState([]);

  const handlecreateform = () => {
    dispatch(openModal("addFeePlan"));
  };
  const getColumnData = (data) => {
    return data.map((item) => ({
      name: (
        <LogoWithName
          name={item.name}
          icon={item.name[0]}
          iconBgColor="#E4EEFF"
          iconColor="#3E7BFA"
        />
      ),
      math: item.math,
      science: item.science,
      social: item.social,
      english: item.english,
    }));
  };
  

  const displayData = getColumnData(data);

  const ActionsData = [
    {
      label: "Send Invite",
      onclick: () => {
        console.log("send invite");
      },
    },
    {
      label: "Update Rooms",
      onclick: () => {
        dispatch(openModal("updateRoom"));
      },
    },
    {
      label: "Update Status",
      onclick: () => {
        dispatch(openModal("statusUpdate"));
      },
    },
    {
      label: "Update Groups",
      onclick: () => {
        dispatch(openModal("updateGroups"));
      },
    },
    {
      label: "Transfer Student",
      onclick: () => {
        dispatch(openModal("TransferStudent"));
      },
    },
    {
      label: "Create Folder",
      onclick: () => {
        dispatch(openModal("createFolder"));
      },
    },
  ];

  const headingsData = [
    { title: "Student Name", accessor: "name" },
    { title: "Math Worksheet", accessor: "math" },
    { title: "Science Quiz", accessor: "science" },
    { title: "Social Report", accessor: "social" },
    { title: "English Essay", accessor: "english" },
  ];
  

  return (
    <>
      <div className={styles.container}>
        {/* Search and Filters */}
        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.search}>
              <SearchBar
                placeholder="Search by student name"
                onChange={(e) => console.log(e.target.value)}
              />
            </div>
            <div className={styles.filters}>
              <CalendarInput
                label="Date"
                value={selectedDate}
                onChange={setSelectedDate}
                background="var(--Utility_Color1)"
                textColor="gray"
                iconColor="gray"
                placeholderColor="gray"
                borderRadius="25px"
                shadow={false}
              />

              <Dropdown label="Room" options={["Live", "Inactive", "Draft"]} />
            </div>
          </div>

          {/* Student Data Table */}
          <div>
            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Assignments;
